<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('CONTACT')">
        <slot name="section-contact">
          <section-contact ref="CONTACT"
                           id="CONTACT"
                           :extended="isExtended('CONTACT')"
                           :showButton="true"
                           :autoSave="true"
                           :readOnly="readOnly"
                           :moduleId="moduleId"
                           :searchText="searchText"
                           :ressourceHeader="ressource"
                           :fiche="fiche"
                           :toggleResetCiviliteSelect="toggleResetCiviliteSelect"
                           :toggleResetQualiteSelect="toggleResetQualiteSelect"
                           :contact=selectedContact
                           :route="route"
                           :attribut="attribut"
                           @extended="setExtended"
                           @fullscreen="setFullscreen"
                           @status="updateStatus"
                           @updated="contactUpdated"
                           @selectItem = "selectItem">
          </section-contact>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('ADRESSE')">
        <slot name="section-adresse">
          <section-adresse ref="ADRESSE"
                           id="ADRESSE"
                           :extended="isExtended('ADRESSE')"
                           :showButton="true"
                           :autoSave="true"
                           :readOnly="readOnly"
                           :moduleId="moduleId"
                           :searchText="searchText"
                           :ressourceHeader="ressource"
                           :fiche="fiche"
                           :toggleResetPaysSelect="toggleResetPaysSelect"
                           :adresse=selectedAdresse
                           :route="route"
                           :attribut="attribut"
                           @extended="setExtended"
                           @fullscreen="setFullscreen"
                           @status="updateStatus"
                           @updated="adresseUpdated"
                           @selectItem = "selectItem">
          </section-adresse>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Contact from '@/extend/classes/Contact';
import Adresse from '@/extend/classes/Adresse';
import { storeAdresse } from '@/generated/stores';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionContact from '@/extend/sections/SectionContactExtend.vue';
import SectionAdresse from '@/extend/sections/SectionAdresseExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionContact,
    SectionAdresse,
    FicheHeader,
  },

  props: {
    contact: {
      type: Object as PropType<Contact>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.PROFIL,
      sections: [
        'CONTACT',
        'ADRESSE',
      ],

      toggleResetCiviliteSelect: false,
      toggleResetQualiteSelect: false,
      adresse: new Adresse(),
      toggleResetPaysSelect: false,
    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_PROFIL);
    },

    selectedContact (): Contact {
      return this.contact
    },
    selectedAdresse (): Adresse {
      if (this.contact.adresseId == 0) {
        return storeAdresse.createNewAdresse();
      } else {
        return storeAdresse.getAdresse(this.contact.adresseId);
      }
    },

  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    contactUpdated (contact: Contact) {
    // To implement
    },

    // eslint-disable-next-line
    adresseUpdated (adresse: Adresse) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.contact || this.contact.id < 0) && value == 'CONTACT') {
        this.setExtended(new Extended('CONTACT', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
